const items = [
    "UI/UX Design",
    "Product Design",
    "User Research",
    "Interaction Design",
    "Design Systems",
    "AI",
    "Visual Design",
    "Prototyping",
];

const Strip = () => (
    <div className="flex shrink-0 items-center">
        {items.map((item, i) => (
            <span key={item} className="flex items-center">
                <span
                    className={`whitespace-nowrap px-7 text-sm font-extrabold uppercase tracking-[0.22em] ${
                        i % 2 === 1 ? "text-outline" : "text-ink"
                    }`}
                >
                    {item}
                </span>
                <span className="text-lg text-viol">✦</span>
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div className="relative z-10 my-4" data-testid="marquee-strip">
            <div className="marquee-paused -rotate-1 overflow-hidden border-y-2 border-ink/80 bg-sun py-4 shadow-[0_18px_45px_rgba(255,216,77,0.3)]">
                <div className="animate-marquee flex w-max">
                    <Strip />
                    <Strip />
                </div>
            </div>
        </div>
    );
}
